import React from "react";
import { fmt, fmtSigned } from "./financeUtils";

/**
 * Gelir–Gider Tablosu (artifact `.stmt-*`).
 * incomeRows / expenseRows: [{key,label,amount,count}] from groupByCategory.
 * onRowClick(row, kind) opens the detail sheet.
 */
const SectionRows = ({ rows, kind, onRowClick }) => {
  const total = rows.reduce((s, r) => s + r.amount, 0);
  const color = kind === "income" ? "var(--fin-pos)" : "var(--fin-neg)";
  if (!rows.length) {
    return (
      <div className="px-4 py-3 text-[12px] text-[var(--fin-muted)]">
        Bu dönemde kayıt yok.
      </div>
    );
  }
  return (
    <>
      {rows.map((r) => (
        <button
          key={r.key}
          onClick={() => onRowClick(r, kind)}
          className="w-full flex justify-between items-center gap-3 px-4 py-2 text-[13px] border-b border-[var(--fin-row-line)] hover:bg-[var(--fin-hover)] transition-colors text-left"
        >
          <span className="flex items-center gap-2 min-w-0">
            <span
              className="w-[7px] h-[7px] rounded-[2px] shrink-0"
              style={{ background: color }}
            />
            <span className="truncate text-[var(--fin-text)]">{r.label}</span>
          </span>
          <span className="shrink-0">
            <span className="fin-grot fin-num font-semibold text-[13.5px]" style={{ color }}>
              {fmt(r.amount)}
            </span>
            <span className="fin-num text-[10.5px] text-[var(--fin-muted)] ml-1.5 font-medium">
              %{total ? Math.round((r.amount / total) * 100) : 0}
            </span>
          </span>
        </button>
      ))}
    </>
  );
};

const IncomeStatement = ({ incomeRows, expenseRows, onRowClick }) => {
  const incTotal = incomeRows.reduce((s, r) => s + r.amount, 0);
  const expTotal = expenseRows.reduce((s, r) => s + r.amount, 0);
  const net = incTotal - expTotal;

  return (
    <section>
      <div className="flex justify-between items-baseline mx-1 mb-2">
        <h2 className="fin-grot text-[14px] font-semibold text-[var(--fin-text)]">
          Gelir–Gider Tablosu
        </h2>
        <span className="text-[11px] text-[var(--fin-muted)]">satıra dokun → detay</span>
      </div>
      <div className="fin-card">
        <div className="flex justify-between px-4 pt-2.5 pb-1.5 text-[11px] font-bold uppercase tracking-[0.08em] text-[var(--fin-pos)]">
          <span>Gelirler</span>
          <span className="fin-grot fin-num">{fmt(incTotal)}</span>
        </div>
        <SectionRows rows={incomeRows} kind="income" onRowClick={onRowClick} />

        <div className="flex justify-between px-4 pt-2.5 pb-1.5 text-[11px] font-bold uppercase tracking-[0.08em] text-[var(--fin-neg)]">
          <span>Giderler</span>
          <span className="fin-grot fin-num">{fmt(expTotal)}</span>
        </div>
        <SectionRows rows={expenseRows} kind="expense" onRowClick={onRowClick} />

        <div className="flex justify-between items-center px-4 py-[13px] text-[14px] font-bold bg-[var(--fin-net-bg)] text-[var(--fin-net-fg)]">
          <span>NET KÂR / ZARAR</span>
          <span
            className="fin-grot fin-num text-[16px]"
            style={{ color: net >= 0 ? "#7fe3bd" : "#f5b3ac" }}
          >
            {fmtSigned(net)}
          </span>
        </div>
      </div>
    </section>
  );
};

export default IncomeStatement;
